import { SITE_ORIGIN } from './siteConfig';
import { ORGANIZATION_SCHEMA_ID } from './organizationSchema';

const TELEPHONE = '+447864841709';

const AUTHORITY = {
  truro: {
    name: 'WebCodeCraft - Truro Web Design',
    slug: 'truro',
    addressLocality: 'Truro',
    addressRegion: 'Cornwall',
    description:
      'Professional, zero-upfront-cost web design and SEO for businesses in Truro and Cornwall.',
    areaServed: [
      'Truro',
      'Falmouth',
      'St Austell',
      'Redruth',
      'Penryn',
      'TR1',
      'TR2',
      'TR3',
      'TR4',
      'TR5',
      'TR6',
      'EX22',
      'EX23'
    ]
  },
  falmouth: {
    name: 'WebCodeCraft - Falmouth Web Design',
    slug: 'falmouth',
    addressLocality: 'Falmouth',
    addressRegion: 'Cornwall',
    description:
      'Professional, zero-upfront-cost web design and SEO for businesses in Falmouth and Cornwall\u2019s coast.',
    areaServed: [
      'Falmouth',
      'Truro',
      'Penryn',
      'Helston',
      'St Austell',
      'TR10',
      'TR11',
      'TR1',
      'TR2',
      'TR13'
    ]
  },
  barnstaple: {
    name: 'WebCodeCraft - Barnstaple Web Design',
    slug: 'barnstaple',
    addressLocality: 'Barnstaple',
    addressRegion: 'Devon',
    description:
      'Professional, zero-upfront-cost web design and SEO for businesses in Barnstaple and North Devon.',
    areaServed: [
      'Barnstaple',
      'Bideford',
      'Ilfracombe',
      'South Molton',
      'Braunton',
      'EX31',
      'EX32',
      'EX33',
      'EX34',
      'EX35',
      'EX39'
    ]
  },
  bideford: {
    name: 'WebCodeCraft - Bideford Web Design',
    slug: 'bideford',
    addressLocality: 'Bideford',
    addressRegion: 'Devon',
    description:
      'Professional, zero-upfront-cost web design and SEO for businesses in Bideford and the Torridge coast.',
    areaServed: [
      'Bideford',
      'Northam',
      'East-the-Water',
      'Appledore',
      'Westward Ho!',
      'EX39'
    ]
  },
  'south-molton': {
    name: 'WebCodeCraft - South Molton Web Design',
    slug: 'south-molton',
    addressLocality: 'South Molton',
    addressRegion: 'Devon',
    description:
      'Professional, zero-upfront-cost web design and SEO for businesses in South Molton and Exmoor gateway.',
    areaServed: ['South Molton', 'North Molton', 'Exmoor', 'EX36']
  },
  padstow: {
    name: 'WebCodeCraft - Padstow Web Design',
    slug: 'padstow',
    addressLocality: 'Padstow',
    addressRegion: 'Cornwall',
    description:
      'Professional, zero-upfront-cost web design and SEO for businesses in Padstow and the Camel estuary.',
    areaServed: ['Padstow', 'St Merryn', 'Trevone', 'Wadebridge', 'PL28']
  },
  newquay: {
    name: 'WebCodeCraft - Newquay Web Design',
    slug: 'newquay',
    addressLocality: 'Newquay',
    addressRegion: 'Cornwall',
    description:
      'Professional, zero-upfront-cost web design and SEO for businesses in Newquay and the north Cornwall coast.',
    areaServed: ['Newquay', 'Crantock', 'Porth', 'TR7', 'TR8']
  },
  'st-ives': {
    name: 'WebCodeCraft - St Ives Web Design',
    slug: 'st-ives',
    addressLocality: 'St Ives',
    addressRegion: 'Cornwall',
    description:
      'Professional, zero-upfront-cost web design and SEO for businesses in St Ives and west Cornwall.',
    areaServed: ['St Ives', 'Carbis Bay', 'Halsetown', 'TR26', 'TR27']
  }
};

export function getAuthorityLocalBusinessNode(slug) {
  const key = String(slug || '').toLowerCase();
  const row = AUTHORITY[key];
  if (!row) return null;
  const url = `${SITE_ORIGIN}/locations/${row.slug}`;
  return {
    '@type': 'LocalBusiness',
    '@id': `${url}#localbusiness`,
    name: row.name,
    url,
    telephone: TELEPHONE,
    parentOrganization: { '@id': ORGANIZATION_SCHEMA_ID },
    address: {
      '@type': 'PostalAddress',
      addressLocality: row.addressLocality,
      addressRegion: row.addressRegion,
      addressCountry: 'GB'
    },
    areaServed: row.areaServed,
    description: row.description
  };
}
